module.exports = __webpack_public_path__ + "static/media/3.b42c1252.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/avatars/3.png
 ** module id = 212
 ** module chunks = 0
 **/